/* eslint-disable */
import SingleBlog from './SingleBlog'
import Pagination from './Pagination'
import { Spinner } from '../UI/Spinner'
import Nav from './Nav'
import { pagination, categories } from '../../blog.config'
import { useEffect, useState } from 'react'
import {
  Posts,
  Title,
  FeaturedImg,
  Category,
  Author,
  Tag
} from '../../models/blog'

interface PostData {
  id: number
  title: Title
  diff: {
    m: number
    y: number
  }
  slug: string
  content: string
  featuredImg: FeaturedImg
  category: Category[]
  author: Author
  totalComments: string
  publishedDate: Date
  tags: Tag[]
  excerpt: string
  publishDate: any
}
interface PropsData {
  posts?: Posts[]
  hideCategory?: boolean
  categorySlug?: string
}
export const BlogContainer = (props: PropsData) => {
  const { posts, hideCategory } = props
  const [postsData, setPostsData] = useState(posts)
  const [isLoaded, setIsLoaded] = useState(false)

  const [currentPage, setCurrentPage] = useState(1)
  /**
   * PAGINATION LOGIC
   */
  const [postsPerPage] = useState(pagination.postPerPage)
  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts =
    postsData !== undefined
      ? postsData.slice(indexOfFirstPost, indexOfLastPost)
      : []
  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber)
    window.scrollTo({ top: 10, behavior: 'smooth' })
  }
  /**
   *
   * PAGINATION LOGIC ENDS
   *
   */

  useEffect(() => {
    setPostsData(posts)
    setIsLoaded(true)
  }, [posts])

  if (isLoaded) {
    return (
      <div>
        {!hideCategory && (
          <>
            <Nav categories={categories} />
          </>
        )}

        <div className="blog-container pb-24">
          <div className="blog-wrapper">
            {currentPosts &&
              currentPosts.map((post: PostData) => (
                <SingleBlog {...post} key={post.id} />
              ))}
          </div>
          {posts && (
            <Pagination
              postsPerPage={postsPerPage}
              totalPosts={posts.length}
              paginate={paginate}
              currentPage={currentPage}
            />
          )}
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="flex justify-center">
        <Spinner />
      </div>
    </>
  )
}

export default BlogContainer
